import { memo } from "react";
import { Box, Grid, Paper, Tab, Tabs } from "@mui/material";
import { AdminPanelSettings, Person } from "@mui/icons-material";
import type { TeleconsultoriaViewMode } from "../hooks/useTeleconsultoriaViewAccess";

/**
 * Seletor "Visão Profissional" / "Visão Clínica".
 * Mesmo padrão visual do Pronto Atendimento (`PaViewTabs`): Tabs locais e
 * centralizadas, sem mexer no ViewContext global.
 */
export const TeleconsultoriaViewTabs = memo(function TeleconsultoriaViewTabs({
  value,
  onChange,
}: {
  value: TeleconsultoriaViewMode;
  onChange: (value: TeleconsultoriaViewMode) => void;
}) {
  return (
    <Paper elevation={0} sx={{ borderRadius: 1, overflow: "hidden" }}>
      <Grid container spacing={2} sx={{ pb: 1.5, px: 2 }} alignItems="center">
        {/* Espaços laterais mantêm as Tabs centralizadas (igual ao dashboard). */}
        <Grid item xs={false} sm={4} sx={{ display: { xs: "none", sm: "block" } }} />
        <Grid item xs={12} sm={4}>
          <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
            <Tabs
              value={value}
              onChange={(_event, next: TeleconsultoriaViewMode | null) => {
                if (next) onChange(next);
              }}
              centered
            >
              <Tab
                value="professional"
                label={
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Person sx={{ mr: 1 }} />
                    Visão Profissional
                  </Box>
                }
              />
              <Tab
                value="clinic"
                label={
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <AdminPanelSettings sx={{ mr: 1 }} />
                    Visão Clínica
                  </Box>
                }
              />
            </Tabs>
          </Box>
        </Grid>
        <Grid item xs={false} sm={4} sx={{ display: { xs: "none", sm: "block" } }} />
      </Grid>
    </Paper>
  );
});
